import gql from 'graphql-tag'
import { PageInfoFragment, AssetTagEmployeeDetailsFragment } from '@api/fragments'
import { IPageInfo, IEmployee } from '@api/types'
import client from '@stores/apollo'

interface AssetEmployeeVars {
  id: string
  first: number
  after?: string
  query?: string
}

const employeeQuery = gql`
  query assetEmployees($id: ID!, $after: String, $where: EmployeeWhereInput, $first: Int) {
    node(id: $id) {
      ... on Tag {
        employees(after: $after, where: $where, orderBy: name_ASC, first: $first) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...AssetTagEmployeeDetailsFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${AssetTagEmployeeDetailsFragment}
`

export default function list({
  id,
  first = 5,
  query = '',
  after = '',
}: AssetEmployeeVars): Promise<{
  counters: {
    total: number
  }
  pageInfo: IPageInfo
  employees: IEmployee[]
}> {
  return client.gql
    .query({
      query: employeeQuery,
      variables: {
        id,
        first,
        after,
        where: {
          // eslint-disable-next-line
          OR: [{ name_contains: query }, { email_contains: query }],
        },
      },
    })
    .then(
      ({
        data: {
          node: {
            employees: { counters, edges, pageInfo },
          },
        },
      }: {
        data: {
          node: {
            employees: {
              pageInfo: IPageInfo
              counters: { total: number }
              edges: { node: IEmployee }[]
            }
          }
        }
      }) => ({
        counters,
        pageInfo,
        employees: edges.map(({ node }) => node),
      })
    )
}
